import BigNumber from "bignumber.js";
import ABI from "src/contract-logic/abis/NFTVaultABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

function getContractFactory(contractAddress, options) {
  const { decimals } = options;
  const BASE = Math.pow(10, decimals);
  const web3Sender = getWeb3Sender();
  var contractReader = new web3Reader.eth.Contract(ABI, contractAddress);
  var contractSender = new web3Sender.eth.Contract(ABI, contractAddress);

  if (!contractReader || !contractSender) {
    throw new Error(`Cannot create nft-vault contract from address ${contractAddress}`);
  }

  return {
    getTotalRewardsBalance: async (stakerAddress) => {
      const rewardRaw = await contractReader.methods.getTotalRewardsBalance(stakerAddress).call();
      return BigNumber(rewardRaw).dividedBy(BASE);
    },
    depositNFT: async (dispatch, collectionId, accountAddress) => {
      const emit = contractSender.methods.stake(collectionId).send({ from: accountAddress });
      handleEmit(dispatch, emit, "Deposit Collection");
      await emit;
    },
    withdrawNFT: async (dispatch, accountAddress) => {
      const emit = contractSender.methods.redeem().send({ from: accountAddress });
      handleEmit(dispatch, emit, "Withdraw Collection");
      await emit;
    },
    claimReward: async (dispatch, accountAddress) => {
      const emit = contractSender.methods.claimReward().send({ from: accountAddress });
      handleEmit(dispatch, emit, "Claim Reward");
      await emit;
    },
    isStaked: async (accountAddress) => {
      const isStaked = await contractSender.methods.stakedNFT(accountAddress).call();
      return isStaked;
    },
    polishNFT: async (dispatch, accountAddress) => {
      const emit = contractSender.methods.polishCollection().send({ from: accountAddress });
      handleEmit(dispatch, emit, "Polish");
      await emit;
    },
    getCurrentDecayStatus: async (accountAddress) => {
      const decayStatus = await contractReader.methods.getCurrentDecayStatus(accountAddress).call();
      return BigNumber(decayStatus).dividedBy(100);
    },
    getStakedCollectionId: async (accountAddress) => {
      const res = await contractReader.methods.stakerNFT(accountAddress).call();
      return parseInt(res);
    },
    getCurrentExperience: async (accountAddress) => {
      const res = await contractReader.methods.getExperience().call({ from: accountAddress });
      return parseInt(res);
    },
    getDepositTime: async (accountAddress) => {
      const res = await contractReader.methods.depositTime(accountAddress).call();
      return parseInt(res);
    },
    assetData: async () => {
      const res = await contractReader.methods.assetData().call();
      return res;
    },
  };
}

export default { getContractFactory };
